<!-- #nameCard is declared here, outside the @if/@else, so both the
     template-1 and classic branches below can reference it — a
     template reference variable declared inside one @if/@else branch
     is not visible from the sibling branch. -->
<ng-template #nameCard let-player="player" let-type="type" let-mini="mini" let-item="item" let-index="index"
  let-img_details="img_details" let-selected_parents="selected_parents">
  <div id="st-common-score-cards-name-card-wrapper" class="name-card-wrapper">
    <ng-container *ngIf="selected_parents?.length > 0">

      <img class="t1-sc-flag" stupaLogoTone [src]="get_player_flag(selected_parents, player)" alt=""
        *ngIf="(item.category.participant_type_id !== 2 || index !== 1) && hasPlayerFlag(selected_parents, player)" />
    </ng-container>
    <p class="player-name"
      [attr.data-abbr]="item.category.participant_type_id === 2 ? null : (get_player_abbr(selected_parents, player) || playerAbbr(player?.name))"
      [ngClass]="{
        'serving-player':
          item.live_score_json?.ServiceBy ===
            item.participants[type - 1]?.participant_id && item.winner == null,
        'hold-player':
          item.live_score_json?.ServiceBy !==
            item.participants[type - 1]?.participant_id && item.winner == null,
        'winner-player':
          item.winner != null &&
          item.winner === item.participants[type - 1]?.participant_id,
        'loser-player':
          item.winner != null &&
          item.winner !== item.participants[type - 1]?.participant_id
      }">
      {{
      item.category.participant_type_id === 2
      ? get_sub_match(item, item.sub_matches, type, index)
      : playerName(player?.name, mini)
      }}
    </p>
  </div>
</ng-template>

<!-- Shared serve-icon glyph — sides A/B render the identical SVG, and the team-tie
     layout (below) needs it positioned next to the score instead of next to the name,
     so it's one reusable template rather than duplicating the markup a third time. -->
<ng-template #t1ServeIcon>
  <svg class="t1-sc-serve" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M1.3125 0C0.592812 0 0 0.592812 0 1.3125C0 2.03219 0.592812 2.625 1.3125 2.625C2.03219 2.625 2.625 2.03219 2.625 1.3125C2.625 0.592812 2.03219 0 1.3125 0ZM6.53537 0.396375C6.3982 0.398832 6.26124 0.408177 6.125 0.424375C5.04481 0.550812 4.03681 1.10425 3.26769 1.87337C2.72737 2.4115 2.27981 3.18587 2.13281 4.62131C2.12752 4.63476 2.123 4.64849 2.11925 4.66244V4.676C2.10827 4.69813 2.09905 4.7211 2.09169 4.74469C2.08994 4.75475 2.09344 4.76 2.09169 4.77181V4.8265C2.09576 4.88316 2.10967 4.93868 2.13281 4.99056C2.15469 5.38387 2.20981 5.7855 2.35156 6.16656H2.338C2.34456 6.20419 2.38919 6.39187 2.39269 6.5765C2.39444 6.71519 2.34456 6.84162 2.338 6.8775C2.07112 7.14219 1.75175 7.41912 1.44944 7.65669C1.14669 7.89425 0.885062 8.09944 0.696937 8.28581H0.683812C0.571361 8.40426 0.489017 8.548 0.443715 8.70492C0.398414 8.86184 0.391481 9.02734 0.4235 9.1875C0.49 9.49375 0.665875 9.75844 0.901687 9.99425C1.13619 10.2283 1.40262 10.4024 1.70844 10.4724C2.01469 10.5424 2.38525 10.4523 2.62456 10.213C2.81619 10.0214 3.00081 9.75144 3.23969 9.44737C3.479 9.14287 3.75069 8.813 4.01887 8.54481C3.98825 8.57544 4.12169 8.50412 4.29275 8.50412C4.431 8.50412 4.54562 8.51725 4.634 8.53125C4.65675 8.53475 4.70269 8.54306 4.71625 8.54481C5.09731 8.68656 5.49937 8.73994 5.89225 8.76356C5.89706 8.76356 5.901 8.77756 5.90581 8.77756C5.93644 8.78587 5.96925 8.78937 6.00163 8.79069C6.01492 8.79611 6.0285 8.80078 6.04231 8.80469H6.125C6.15256 8.80294 6.17969 8.79769 6.20725 8.79112C6.22431 8.78937 6.23088 8.77887 6.24794 8.77712H6.26194C7.57925 8.66775 8.46256 8.19087 9.02344 7.62869C9.79256 6.86 10.346 5.85156 10.4729 4.77181C10.5993 3.69119 10.2624 2.53794 9.31044 1.58594C8.47831 0.753812 7.49219 0.389813 6.53537 0.396375ZM1.3125 0.875C1.55881 0.875 1.75 1.06662 1.75 1.3125C1.75 1.55881 1.55837 1.75 1.3125 1.75C1.06619 1.75 0.875 1.55837 0.875 1.3125C0.875 1.06619 1.06662 0.875 1.3125 0.875ZM6.53537 1.27137C7.27344 1.25781 8.01325 1.51944 8.69531 2.20106C9.47625 2.98025 9.69719 3.83294 9.59787 4.67556C9.49856 5.51819 9.05581 6.36606 8.40788 7.01356C7.97256 7.44931 7.34037 7.78969 6.23437 7.88856L3.00781 4.662C3.136 3.42825 3.44006 2.95837 3.89637 2.50206C4.54387 1.85456 5.37644 1.39781 6.22081 1.29894C6.32669 1.28669 6.4295 1.27312 6.53537 1.27137ZM3.21256 6.125L4.77094 7.66981C4.61289 7.64232 4.45273 7.6287 4.29231 7.62912C4.02587 7.63044 3.68769 7.64619 3.40419 7.92969C3.10276 8.23637 2.81964 8.56054 2.55631 8.9005C2.31175 9.21112 2.09475 9.49856 1.99588 9.59744C1.94425 9.64906 1.96962 9.64031 1.89962 9.625C1.82962 9.60969 1.68787 9.52262 1.53081 9.36512C1.37681 9.21156 1.30025 9.06937 1.2845 8.99631C1.26919 8.92281 1.25387 8.94294 1.2985 8.90006C1.39037 8.80819 1.66906 8.58594 1.98187 8.34006C2.29469 8.09375 2.65169 7.80631 2.96625 7.49219C3.269 7.18987 3.2725 6.83944 3.26725 6.5625C3.26375 6.3525 3.23137 6.22912 3.21256 6.125Z" fill="currentColor" />
  </svg>
</ng-template>

@if (isTemplate1) {
<!-- ============================================================
     TEMPLATE 1 (OTT) — reference-matched score card
     (LA48AF_1_updated.HTM `.sc` cards). Reuses #nameCard and every
     data helper below unchanged — only the DOM/CSS differ from the
     classic card, per the project's template-switch convention.
     ============================================================ -->
<div class="t1-sc" [class.t1-sc--team]="item.category.participant_type_id === 2"
  [class.t1-sc--doubles]="item.category.participant_type_id > 1"
  (click)="navigate_to_scores()">
  <div class="t1-sc-bar">
    <div class="t1-sc-bar-row1">
      <span class="t1-sc-event-name" [title]="(item.category | categoryDisplayLabel) + ' · ' + item.round.name">
        {{ (item.category | categoryDisplayLabel) }} · {{ item.round.name }}
      </span>
      <span class="t1-sc-badge" [class.t1-sc-badge--live]="!isMatchCompleted(item)">
        <span class="t1-sc-badge-dot" *ngIf="!isMatchCompleted(item)"></span>
        {{ isMatchCompleted(item) ? ('completed' | translate) : ('live' | translate) }}
      </span>
    </div>
    <div class="t1-sc-bar-row2" *ngIf="gettables(item)">
      <span class="t1-sc-table-tag">{{ 'table' | translate | titlecase }}<b>{{ gettables(item) }}</b></span>
    </div>
  </div>

  <!-- Reference `.sc-body`: the card body holds the score rows and the
       team-tie footer. The board-by-board breakdown is no longer an inline
       deck beside them; it opens as a full-screen dialog (see the bottom of
       this file). -->
  <div class="t1-sc-body">
    <div class="t1-sc-main">
      <div class="t1-sc-stack">
        <!-- side A -->
        <div class="t1-sc-side">
          <div class="t1-sc-side-info" [class.t1-sc-side-info--team-dbl]="item.category.participant_type_id === 2 && t1SideAView.hasActiveBoard">
            <ng-container *ngIf="item.category.participant_type_id === 1">
              <ng-container *ngTemplateOutlet="nameCard; context: {
                  player: item?.participants[0]?.participant_details[0], type: 1, mini: false, item: item, index: 0,
                  img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
            </ng-container>
            <div class="t1-sc-side-players" *ngIf="item.category.participant_type_id > 1 && item.category.participant_type_id !== 2">
              <ng-container *ngTemplateOutlet="nameCard; context: {
                  player: item?.participants[0]?.participant_details[0], type: 1, mini: false, item: item, index: 0,
                  img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
              <ng-container *ngTemplateOutlet="nameCard; context: {
                  player: item?.participants[0]?.participant_details[1], type: 1, mini: false, item: item, index: 1,
                  img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
            </div>
            <!-- Team tie: currently active board, reference `layoutTeamDoublesCard` —
                 any active board (singles or doubles) shows the team header above
                 the player line(s); only "no active board" (not started/completed)
                 shows the team name alone. -->
            <ng-container *ngIf="item.category.participant_type_id === 2">
              @if (t1SideAView.hasActiveBoard) {
                <div class="t1-sc-side-team-row">
                  <img class="t1-sc-flag" stupaLogoTone [src]="t1SideAView.teamFlag" alt="" *ngIf="t1SideAView.teamFlag" />
                  <span class="t1-sc-side-team">{{ t1SideAView.parentLabel }}</span>
                </div>
                <div class="t1-sc-side-players">
                  @for (name of t1SideAView.names; track name; let i = $index) {
                    <div class="t1-sc-dbl-line">
                      <img class="t1-sc-flag" stupaLogoTone [src]="t1SideAView.flags[i]" alt="" *ngIf="t1SideAView.flags[i]" />
                      <span class="player-name" [attr.data-abbr]="t1SideAView.abbrs[i]">{{ name }}</span>
                    </div>
                  }
                </div>
              } @else {
                <img class="t1-sc-flag" stupaLogoTone [src]="t1SideAView.flag" alt="" *ngIf="t1SideAView.flag" />
                <span class="player-name" [attr.data-abbr]="t1SideAView.abbr">{{ t1SideAView.names[0] }}</span>
              }
            </ng-container>
          </div>
          <div class="t1-sc-side-scores">
            <!-- Serve glyph always sits with the score it refers to, never with the
                 player name — same rule for singles, doubles, and every team-tie state. -->
            <ng-container *ngIf="item.live_score_json?.ServiceBy === item.live_score_json?.participant_id_A && item.winner == null">
              <ng-container *ngTemplateOutlet="t1ServeIcon"></ng-container>
            </ng-container>
            <img class="t1-sc-card" src="../../../../assets/icons_svg/yellow_card.svg" alt=""
              *ngIf="item.live_score_json?.PlayerAyellowCardCount > 0" />
            <img class="t1-sc-card" src="../../../../assets/SvgIcons/1_half.svg" alt=""
              *ngIf="item.live_score_json?.PlayerAredCardCount == 1" />
            <img class="t1-sc-card" src="../../../../assets/SvgIcons/2_half.svg" alt=""
              *ngIf="item.live_score_json?.PlayerAredCardCount == 2" />
            <span class="t1-sc-box" *ngIf="shouldShowLiveScoreBlock(item)">{{ item?.live_score_json?.sets?.[0]?.score_A }}</span>
            <span class="t1-sc-box t1-sc-box--set" [class.t1-sc-box--win]="item.category.participant_type_id === 2 ? t1SideAView.isWin : (item.winner != null && item.winner === item.participants[0]?.participant_id)">
              {{ item.category.participant_type_id === 2 ? t1SideAView.score : item.participants[0]?.sets_won }}
            </span>
          </div>
        </div>
        <!-- side B -->
        <div class="t1-sc-side">
          <div class="t1-sc-side-info" [class.t1-sc-side-info--team-dbl]="item.category.participant_type_id === 2 && t1SideBView.hasActiveBoard">
            <ng-container *ngIf="item.category.participant_type_id === 1">
              <ng-container *ngTemplateOutlet="nameCard; context: {
                  player: item?.participants[1]?.participant_details[0], type: 2, mini: false, item: item, index: 0,
                  img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
            </ng-container>
            <div class="t1-sc-side-players" *ngIf="item.category.participant_type_id > 1 && item.category.participant_type_id !== 2">
              <ng-container *ngTemplateOutlet="nameCard; context: {
                  player: item?.participants[1]?.participant_details[0], type: 2, mini: false, item: item, index: 0,
                  img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
              <ng-container *ngTemplateOutlet="nameCard; context: {
                  player: item?.participants[1]?.participant_details[1], type: 2, mini: false, item: item, index: 1,
                  img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
            </div>
            <ng-container *ngIf="item.category.participant_type_id === 2">
              @if (t1SideBView.hasActiveBoard) {
                <div class="t1-sc-side-team-row">
                  <img class="t1-sc-flag" stupaLogoTone [src]="t1SideBView.teamFlag" alt="" *ngIf="t1SideBView.teamFlag" />
                  <span class="t1-sc-side-team">{{ t1SideBView.parentLabel }}</span>
                </div>
                <div class="t1-sc-side-players">
                  @for (name of t1SideBView.names; track name; let i = $index) {
                    <div class="t1-sc-dbl-line">
                      <img class="t1-sc-flag" stupaLogoTone [src]="t1SideBView.flags[i]" alt="" *ngIf="t1SideBView.flags[i]" />
                      <span class="player-name" [attr.data-abbr]="t1SideBView.abbrs[i]">{{ name }}</span>
                    </div>
                  }
                </div>
              } @else {
                <img class="t1-sc-flag" stupaLogoTone [src]="t1SideBView.flag" alt="" *ngIf="t1SideBView.flag" />
                <span class="player-name" [attr.data-abbr]="t1SideBView.abbr">{{ t1SideBView.names[0] }}</span>
              }
            </ng-container>
          </div>
          <div class="t1-sc-side-scores">
            <!-- Serve glyph always sits with the score it refers to — see side A's
                 identical comment above, mirrored for side B. -->
            <ng-container *ngIf="item.live_score_json?.ServiceBy === item.live_score_json?.participant_id_B && item.winner == null">
              <ng-container *ngTemplateOutlet="t1ServeIcon"></ng-container>
            </ng-container>
            <img class="t1-sc-card" src="../../../../assets/icons_svg/yellow_card.svg" alt=""
              *ngIf="item.live_score_json?.PlayerByellowCardCount > 0" />
            <img class="t1-sc-card" src="../../../../assets/SvgIcons/1_half.svg" alt=""
              *ngIf="item.live_score_json?.PlayerBredCardCount == 1" />
            <img class="t1-sc-card" src="../../../../assets/SvgIcons/2_half.svg" alt=""
              *ngIf="item.live_score_json?.PlayerBredCardCount == 2" />
            <span class="t1-sc-box" *ngIf="shouldShowLiveScoreBlock(item)">{{ item?.live_score_json?.sets?.[0]?.score_B }}</span>
            <span class="t1-sc-box t1-sc-box--set" [class.t1-sc-box--win]="item.category.participant_type_id === 2 ? t1SideBView.isWin : (item.winner != null && item.winner === item.participants[1]?.participant_id)">
              {{ item.category.participant_type_id === 2 ? t1SideBView.score : item.participants[1]?.sets_won }}
            </span>
          </div>
        </div>
      </div>

      @if (item.category.participant_type_id === 2) {
        <!-- A native <button> can't contain nested interactive content (the reference's
             raw DOM does this and relies on the browser's leniency + stopPropagation to
             work around it) — this project's a11y baseline forbids that, so the toggle
             surface is a div+role="button" instead, letting the progress dots below be
             real, validly-nested <button> elements. -->
        <div class="t1-sc-team-foot" role="button" tabindex="0" aria-haspopup="dialog"
          (click)="openSubDlg($event)" (keydown.enter)="openSubDlg($event)"
          (keydown.space)="$event.preventDefault(); openSubDlg($event)">
          <span class="t1-sc-team-progress" *ngIf="t1SubMatchTiles.length">
            @for (tile of t1SubMatchTiles; track tile.id) {
              <button type="button" class="t1-sc-team-step"
                [class.t1-sc-team-step--done]="tile.statusClass === 'done'"
                [class.t1-sc-team-step--live]="tile.statusClass === 'live'"
                [class.t1-sc-team-step--wait]="tile.statusClass === 'wait'"
                [class.t1-sc-team-step--active]="t1SelectedSubMatchTile?.id === tile.id"
                (click)="selectSubMatch(tile, $event)"
                [attr.aria-label]="tile.sideA.names.join(', ') + ' ' + ('vs' | translate) + ' ' + tile.sideB.names.join(', ')">
              </button>
            }
          </span>
          <span class="t1-sc-team-foot-right">
            <span class="t1-sc-team-foot-label">{{ 'template1_sub_matches' | translate }}</span>
            <svg class="t1-sc-team-chev" width="10" height="10" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>
      }
    </div>

  </div>
</div>

<!-- Rendered OUTSIDE `.t1-sc`: the card sets `backdrop-filter` and a hover
     `transform`, either of which makes it the containing block for a
     `position: fixed` descendant. Being a sibling is still not enough here
     (the carousel host above it traps the overlay the same way), so the
     dialog re-parents itself to `.t1-app` on init — see its `ngOnInit`. -->
@if (isSubDlgOpen) {
  <stupa-team-sub-match-dialog
    [teamNameA]="t1SideAView.teamName"
    [teamNameB]="t1SideBView.teamName"
    [teamFlagA]="t1SideAView.teamFlag"
    [teamFlagB]="t1SideBView.teamFlag"
    [teamAScore]="item?.participants?.[0]?.sets_won ?? 0"
    [teamBScore]="item?.participants?.[1]?.sets_won ?? 0"
    [subDlgDate]="item?.slot?.start_time ?? null"
    [subDlgTime]="item?.slot?.start_time ?? null"
    [subMatches]="item?.sub_matches ?? []"
    (closeDialog)="closeSubDlg()"></stupa-team-sub-match-dialog>
}
} @else {

<div class="score_card_wrapper" *ngIf="sport_id==1 && variant === 'classic'" (click)="navigate_to_scores()" (mouseenter)="onHover()"
  (mouseleave)="onLeave()">

  <div id="st-common-score-cards-default-content" #defaultContent class="default-content d-flex flex-column"
    style="gap: 12px">
    <!-- {{item | json}} -->
    <div class="d-flex justify-content-between align-items-center" [ngStyle]="
        screenWidth < 500 && item.category.participant_type_id == 2
          ? { gap: '3rem' }
          : {}
      ">
      <div id="st-common-score-cards-block" class="d-flex flex-column">
        <p class="category_name">
          {{ (item.category | categoryDisplayLabel) + " - " }}
          {{ item.round.name }}
        </p>
        <p class="venue_name" *ngIf="gettables(item)">
          {{'table'|translate | titlecase}} {{ gettables(item) }} | {{ item.start_time | date:'HH:mm' }}
        </p>
        <!-- <p class="venue_name" *ngIf="item.table_ids && item.table_ids.length > 0">
          {{'table_no'|translate}} {{ gettables(item) }} | {{ item.start_time | date:'HH:mm' }}
        </p> -->
      </div>
      <div id="st-common-score-cards-block-1" class="gap-3 d-flex align-items-center justify-content-center">
        <div class="d-flex align-items-center justify-content-center" style="gap: 2px"
          *ngIf="item.category.participant_type_id == 2">
          <div id="st-common-score-cards-teamsetscore" class="team_set_score first f_11 f_500">
            {{ item.point_system === 'set_point_system' ? item.participants[0]?.match_points :
            item.participants[0]?.sets_won }}
          </div>
          <div id="st-common-score-cards-teamsetscore-2" class="team_set_score second f_11 f_500">
            {{ item.point_system === 'set_point_system' ? item.participants[1]?.match_points :
            item.participants[1]?.sets_won }}
          </div>
        </div>
        <div id="st-common-score-cards-scorestatus" class="score_status d-flex align-items-center"
          [ngClass]="isMatchCompleted(item) ? 'completed' : 'live'">
          <div id="st-common-score-cards-dot" class="dot"></div>
          <p>{{ isMatchCompleted(item) ? ('completed' | translate) : ('live' | translate) }}</p>
        </div>
      </div>
    </div>
    <div id="st-common-score-cards-block-3" class="gap-2 d-flex flex-column">
      <!-- player 1 info -->
      <div id="st-common-score-cards-player-score-detail-container" class="player-score-detail-container">
        <div id="st-common-score-cards-block-4" class="gap-3 d-flex align-items-center">
          <div id="st-common-score-cards-block-5" class="d-flex flex-grow-1 justify-content-between">
            <div id="st-common-score-cards-block-6" class="gap-3 d-flex align-items-center">
              <div id="st-common-score-cards-block-7" class="gap-2 d-flex flex-column">
                <ng-container *ngTemplateOutlet="
                    nameCard;
                    context: {
                      player: item?.participants[0]?.participant_details[0],
                      type: 1,
                      mini: true,
                      item: item,
                      index: 0,
                      img_details:item?.participants[0],
                      selected_parents:item?.participants[0]?.selected_parents
                    }
                  "></ng-container>
                <ng-container *ngIf="item.category.participant_type_id > 1">
                  <!-- <p>/</p> -->
                  <ng-container *ngTemplateOutlet="
                      nameCard;
                      context: {
                        player: item?.participants[0]?.participant_details[1],
                        type: 1,
                        mini: true,
                        item: item,
                        index: 1,
                        img_details:item?.participants[0],
                        selected_parents:item?.participants[0]?.selected_parents
                      }
                    "></ng-container>
                </ng-container>
              </div>
              <svg class="service_icon" *ngIf="
                  item.live_score_json?.ServiceBy ===
                    item.live_score_json?.participant_id_A &&
                  item.winner == null
                " width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.0625 0.25C1.34281 0.25 0.75 0.842812 0.75 1.5625C0.75 2.28219 1.34281 2.875 2.0625 2.875C2.78219 2.875 3.375 2.28219 3.375 1.5625C3.375 0.842812 2.78219 0.25 2.0625 0.25ZM7.28537 0.646375C7.1482 0.648832 7.01124 0.658177 6.875 0.674375C5.79481 0.800812 4.78681 1.35425 4.01769 2.12337C3.47737 2.6615 3.02981 3.43587 2.88281 4.87131C2.87752 4.88476 2.873 4.89849 2.86925 4.91244V4.926C2.85827 4.94813 2.84905 4.9711 2.84169 4.99469C2.83994 5.00475 2.84344 5.01 2.84169 5.02181V5.0765C2.84576 5.13316 2.85967 5.18868 2.88281 5.24056C2.90469 5.63387 2.95981 6.0355 3.10156 6.41656H3.088C3.09456 6.45419 3.13919 6.64187 3.14269 6.8265C3.14444 6.96519 3.09456 7.09162 3.088 7.1275C2.82112 7.39219 2.50175 7.66912 2.19944 7.90669C1.89669 8.14425 1.63506 8.34944 1.44694 8.53581H1.43381C1.32136 8.65426 1.23902 8.798 1.19372 8.95492C1.14841 9.11184 1.14148 9.27734 1.1735 9.4375C1.24 9.74375 1.41587 10.0084 1.65169 10.2442C1.88619 10.4783 2.15262 10.6524 2.45844 10.7224C2.76469 10.7924 3.13525 10.7023 3.37456 10.463C3.56619 10.2714 3.75081 10.0014 3.98969 9.69737C4.229 9.39287 4.50069 9.063 4.76887 8.79481C4.73825 8.82544 4.87169 8.75412 5.04275 8.75412C5.181 8.75412 5.29562 8.76725 5.384 8.78125C5.40675 8.78475 5.45269 8.79306 5.46625 8.79481C5.84731 8.93656 6.24937 8.98994 6.64225 9.01356C6.64706 9.01356 6.651 9.02756 6.65581 9.02756C6.68644 9.03587 6.71925 9.03937 6.75163 9.04069C6.76492 9.04611 6.7785 9.05078 6.79231 9.05469H6.875C6.90256 9.05294 6.92969 9.04769 6.95725 9.04112C6.97431 9.03937 6.98088 9.02887 6.99794 9.02712H7.01194C8.32925 8.91775 9.21256 8.44087 9.77344 7.87869C10.5426 7.11 11.096 6.10156 11.2229 5.02181C11.3493 3.94119 11.0124 2.78794 10.0604 1.83594C9.22831 1.00381 8.24219 0.639813 7.28537 0.646375ZM2.0625 1.125C2.30881 1.125 2.5 1.31662 2.5 1.5625C2.5 1.80881 2.30837 2 2.0625 2C1.81619 2 1.625 1.80837 1.625 1.5625C1.625 1.31619 1.81662 1.125 2.0625 1.125ZM7.28537 1.52137C8.02344 1.50781 8.76325 1.76944 9.44531 2.45106C10.2262 3.23025 10.4472 4.08294 10.3479 4.92556C10.2486 5.76819 9.80581 6.61606 9.15788 7.26356C8.72256 7.69931 8.09037 8.03969 6.98437 8.13856L3.75781 4.912C3.886 3.67825 4.19006 3.20837 4.64637 2.75206C5.29387 2.10456 6.12644 1.64781 6.97081 1.54894C7.07669 1.53669 7.1795 1.52312 7.28537 1.52137ZM3.96256 6.375L5.52094 7.91981C5.36289 7.89232 5.20273 7.8787 5.04231 7.87912C4.77587 7.88044 4.43769 7.89619 4.15419 8.17969C3.85276 8.48637 3.56964 8.81054 3.30631 9.1505C3.06175 9.46112 2.84475 9.74856 2.74588 9.84744C2.69425 9.89906 2.71962 9.89031 2.64962 9.875C2.57962 9.85969 2.43787 9.77262 2.28081 9.61512C2.12681 9.46156 2.05025 9.31937 2.0345 9.24631C2.01919 9.17281 2.00387 9.19294 2.0485 9.15006C2.14037 9.05819 2.41906 8.83594 2.73187 8.59006C3.04469 8.34375 3.40169 8.05631 3.71625 7.74219C4.019 7.43987 4.0225 7.08944 4.01725 6.8125C4.01375 6.6025 3.98137 6.47912 3.96256 6.375Z"
                  fill="var(--primary-color)" />
              </svg>
              <img src="../../../../assets/SvgIcons/timeout.svg" alt="" *ngIf="item.PlayerATimeout" class="timeOut" />
              <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"
                *ngIf="item.winner == item.participants[0]?.participant_id">
                <path
                  d="M3.23777 4.87832V2.55373H1.97829C1.9161 2.55373 1.86504 2.57369 1.82512 2.61361C1.7852 2.65353 1.76523 2.70459 1.76523 2.76678V2.96911C1.76523 3.41738 1.90214 3.81834 2.17595 4.172C2.44975 4.52565 2.8037 4.76109 3.23777 4.87832ZM9.43116 4.87832C9.86523 4.76109 10.2192 4.52565 10.493 4.172C10.7668 3.81834 10.9037 3.41738 10.9037 2.96911V2.76678C10.9037 2.70459 10.8837 2.65353 10.8438 2.61361C10.8039 2.57369 10.7528 2.55373 10.6906 2.55373H9.43116V4.87832ZM5.88447 10.0307V7.65811C5.36431 7.60573 4.89856 7.42555 4.48722 7.11759C4.07587 6.80963 3.77697 6.41201 3.5905 5.92475C2.82608 5.83498 2.18079 5.51501 1.65464 4.96486C1.12837 4.41459 0.865234 3.76088 0.865234 3.00373V2.76678C0.865234 2.45963 0.973927 2.1973 1.19131 1.9798C1.40881 1.76242 1.67114 1.65373 1.97829 1.65373H3.23777V1.10525C3.23777 0.798091 3.34647 0.535765 3.56385 0.318265C3.78123 0.10088 4.04356 -0.0078125 4.35083 -0.0078125H8.3181C8.62537 -0.0078125 8.8877 0.10088 9.10508 0.318265C9.32247 0.535765 9.43116 0.798091 9.43116 1.10525V1.65373H10.6906C10.9978 1.65373 11.2601 1.76242 11.4776 1.9798C11.695 2.1973 11.8037 2.45963 11.8037 2.76678V2.96911C11.8037 3.73515 11.5406 4.39659 11.0143 4.95344C10.4881 5.51017 9.84285 5.83394 9.07843 5.92475C8.89196 6.41201 8.59306 6.80963 8.18172 7.11759C7.77037 7.42555 7.30462 7.60573 6.78447 7.65811V10.0307H8.72829C8.85602 10.0307 8.96293 10.0733 9.049 10.1587C9.1352 10.2442 9.17829 10.3503 9.17829 10.477C9.17829 10.6037 9.1352 10.711 9.049 10.7988C8.96293 10.8867 8.85602 10.9306 8.72829 10.9306H3.94064C3.81291 10.9306 3.706 10.8879 3.61993 10.8024C3.53373 10.717 3.49064 10.611 3.49064 10.4843C3.49064 10.3576 3.53373 10.2503 3.61993 10.1625C3.706 10.0746 3.81291 10.0307 3.94064 10.0307H5.88447Z"
                  fill="url(#paint0_linear_5985_18867)" />
                <defs>
                  <linearGradient id="paint0_linear_5985_18867" x1="9.10397" y1="10.9999" x2="-0.126802" y2="1.30758"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="var(--primary-color)" />
                    <stop offset="1" stop-color="#00BFC7" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div id="st-common-score-cards-block-8" class="gap-1 d-flex align-items-center"
              *ngIf="shouldShowLiveScoreBlock(item)">
              <div id="st-common-score-cards-block-9" class="d-flex" style="gap: 2px"
                *ngIf="item.live_score_json?.PlayerAyellowCardCount > 0">
                <img class="card_img" src="../../../../assets/icons_svg/yellow_card.svg" alt="" />
                <!-- <p class="cards_text">
                  x {{ item?.live_score_json.PlayerAyellowCardCount }}
                </p> -->
              </div>
              <div id="st-common-score-cards-block-10" class="d-flex" style="gap: 2px" *ngIf="false">
                <img class="card_img" src="../../../../assets/icons_svg/red_card.svg" alt="" />
                <!-- <p class="cards_text">
                  x {{ item?.live_score_json.PlayerAredCardCount }}
                </p> -->
              </div>
              <div id="st-common-score-cards-block-11" class="d-flex" style="gap: 2px"
                *ngIf="item.live_score_json?.PlayerAredCardCount == 1">
                <img class="card_img" src="../../../../assets/SvgIcons/1_half.svg" alt="" />
              </div>
              <div id="st-common-score-cards-block-12" class="d-flex" style="gap: 2px"
                *ngIf="item.live_score_json?.PlayerAredCardCount == 2">
                <img class="card_img" src="../../../../assets/SvgIcons/2_half.svg" alt="" />
              </div>

              <div id="st-common-score-cards-text-center" class="text-center game_score">
                <!-- {{item.participants[0].score[0] }} -->
                {{ item?.live_score_json?.sets?.[0]?.score_A }}
              </div>
            </div>
          </div>
          <div id="st-common-score-cards-points-container" class="d-flex points-container">
            <div id="st-common-score-cards-all-set-points" class="d-flex all-set-points">
              @for(point of item.participants[0]?.score; track point){
              <div [id]="'st-common-score-cards-points' + (item.point)" class="points">{{ point }}</div>
              }
            </div>
            <div id="st-common-score-cards-setscore" class="set_score upper_data"
              *ngIf="item.category.participant_type_id != 2">
              {{
              item.live_score_json != "winner announced" &&
              item.live_score_json != null &&
              item.winner == null
              ? item.participants[0]?.sets_won
              : item.participants[0]?.sets_won
              }}
            </div>
            <div class="set_score upper_data" *ngIf="item.category.participant_type_id == 2">
              {{
              item.live_score_json != "winner announced" &&
              item.live_score_json != null &&
              item.winner == null
              ? get_set_won(item, item.sub_matches, 1)
              : get_set_won(item, item.sub_matches, 1)
              }}
            </div>
          </div>
        </div>
      </div>
      <!-- player 2 info -->
      <div id="st-common-score-cards-player-score-detail-container-13" class="player-score-detail-container">
        <div id="st-common-score-cards-block-14" class="gap-3 d-flex align-items-center">
          <div id="st-common-score-cards-block-15" class="d-flex flex-grow-1 justify-content-between">
            <div id="st-common-score-cards-block-16" class="gap-3 d-flex align-items-center">
              <div id="st-common-score-cards-block-17" class="gap-2 d-flex flex-column">
                <ng-container *ngTemplateOutlet="
                    nameCard;
                    context: {
                      player: item?.participants[1]?.participant_details[0],
                      type: 2,
                      mini: true,
                      item: item,
                      index: 0,
                      img_details:item?.participants[1],
                      selected_parents:item?.participants[1]?.selected_parents
                    }
                  "></ng-container>
                <ng-container *ngIf="item.category.participant_type_id > 1">
                  <ng-container *ngTemplateOutlet="
                      nameCard;
                      context: {
                        player: item?.participants[1]?.participant_details[1],
                        type: 2,
                        mini: true,
                        item: item,
                        index: 1,
                        img_details:item?.participants[1],
                        selected_parents:item?.participants[1]?.selected_parents
                      }
                    "></ng-container>
                </ng-container>
              </div>
              <svg class="service_icon" *ngIf="
                  item.live_score_json?.ServiceBy ===
                    item.live_score_json?.participant_id_B &&
                  item.winner == null
                " width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.0625 0.25C1.34281 0.25 0.75 0.842812 0.75 1.5625C0.75 2.28219 1.34281 2.875 2.0625 2.875C2.78219 2.875 3.375 2.28219 3.375 1.5625C3.375 0.842812 2.78219 0.25 2.0625 0.25ZM7.28537 0.646375C7.1482 0.648832 7.01124 0.658177 6.875 0.674375C5.79481 0.800812 4.78681 1.35425 4.01769 2.12337C3.47737 2.6615 3.02981 3.43587 2.88281 4.87131C2.87752 4.88476 2.873 4.89849 2.86925 4.91244V4.926C2.85827 4.94813 2.84905 4.9711 2.84169 4.99469C2.83994 5.00475 2.84344 5.01 2.84169 5.02181V5.0765C2.84576 5.13316 2.85967 5.18868 2.88281 5.24056C2.90469 5.63387 2.95981 6.0355 3.10156 6.41656H3.088C3.09456 6.45419 3.13919 6.64187 3.14269 6.8265C3.14444 6.96519 3.09456 7.09162 3.088 7.1275C2.82112 7.39219 2.50175 7.66912 2.19944 7.90669C1.89669 8.14425 1.63506 8.34944 1.44694 8.53581H1.43381C1.32136 8.65426 1.23902 8.798 1.19372 8.95492C1.14841 9.11184 1.14148 9.27734 1.1735 9.4375C1.24 9.74375 1.41587 10.0084 1.65169 10.2442C1.88619 10.4783 2.15262 10.6524 2.45844 10.7224C2.76469 10.7924 3.13525 10.7023 3.37456 10.463C3.56619 10.2714 3.75081 10.0014 3.98969 9.69737C4.229 9.39287 4.50069 9.063 4.76887 8.79481C4.73825 8.82544 4.87169 8.75412 5.04275 8.75412C5.181 8.75412 5.29562 8.76725 5.384 8.78125C5.40675 8.78475 5.45269 8.79306 5.46625 8.79481C5.84731 8.93656 6.24937 8.98994 6.64225 9.01356C6.64706 9.01356 6.651 9.02756 6.65581 9.02756C6.68644 9.03587 6.71925 9.03937 6.75163 9.04069C6.76492 9.04611 6.7785 9.05078 6.79231 9.05469H6.875C6.90256 9.05294 6.92969 9.04769 6.95725 9.04112C6.97431 9.03937 6.98088 9.02887 6.99794 9.02712H7.01194C8.32925 8.91775 9.21256 8.44087 9.77344 7.87869C10.5426 7.11 11.096 6.10156 11.2229 5.02181C11.3493 3.94119 11.0124 2.78794 10.0604 1.83594C9.22831 1.00381 8.24219 0.639813 7.28537 0.646375ZM2.0625 1.125C2.30881 1.125 2.5 1.31662 2.5 1.5625C2.5 1.80881 2.30837 2 2.0625 2C1.81619 2 1.625 1.80837 1.625 1.5625C1.625 1.31619 1.81662 1.125 2.0625 1.125ZM7.28537 1.52137C8.02344 1.50781 8.76325 1.76944 9.44531 2.45106C10.2262 3.23025 10.4472 4.08294 10.3479 4.92556C10.2486 5.76819 9.80581 6.61606 9.15788 7.26356C8.72256 7.69931 8.09037 8.03969 6.98437 8.13856L3.75781 4.912C3.886 3.67825 4.19006 3.20837 4.64637 2.75206C5.29387 2.10456 6.12644 1.64781 6.97081 1.54894C7.07669 1.53669 7.1795 1.52312 7.28537 1.52137ZM3.96256 6.375L5.52094 7.91981C5.36289 7.89232 5.20273 7.8787 5.04231 7.87912C4.77587 7.88044 4.43769 7.89619 4.15419 8.17969C3.85276 8.48637 3.56964 8.81054 3.30631 9.1505C3.06175 9.46112 2.84475 9.74856 2.74588 9.84744C2.69425 9.89906 2.71962 9.89031 2.64962 9.875C2.57962 9.85969 2.43787 9.77262 2.28081 9.61512C2.12681 9.46156 2.05025 9.31937 2.0345 9.24631C2.01919 9.17281 2.00387 9.19294 2.0485 9.15006C2.14037 9.05819 2.41906 8.83594 2.73187 8.59006C3.04469 8.34375 3.40169 8.05631 3.71625 7.74219C4.019 7.43987 4.0225 7.08944 4.01725 6.8125C4.01375 6.6025 3.98137 6.47912 3.96256 6.375Z"
                  fill="var(--primary-color)" />
              </svg>
              <img src="../../../../assets/SvgIcons/timeout.svg" alt="" *ngIf="item.PlayerATimeout" class="timeOut" />
              <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"
                *ngIf="item.winner == item?.participants[1]?.participant_id">
                <path
                  d="M3.23777 4.87832V2.55373H1.97829C1.9161 2.55373 1.86504 2.57369 1.82512 2.61361C1.7852 2.65353 1.76523 2.70459 1.76523 2.76678V2.96911C1.76523 3.41738 1.90214 3.81834 2.17595 4.172C2.44975 4.52565 2.8037 4.76109 3.23777 4.87832ZM9.43116 4.87832C9.86523 4.76109 10.2192 4.52565 10.493 4.172C10.7668 3.81834 10.9037 3.41738 10.9037 2.96911V2.76678C10.9037 2.70459 10.8837 2.65353 10.8438 2.61361C10.8039 2.57369 10.7528 2.55373 10.6906 2.55373H9.43116V4.87832ZM5.88447 10.0307V7.65811C5.36431 7.60573 4.89856 7.42555 4.48722 7.11759C4.07587 6.80963 3.77697 6.41201 3.5905 5.92475C2.82608 5.83498 2.18079 5.51501 1.65464 4.96486C1.12837 4.41459 0.865234 3.76088 0.865234 3.00373V2.76678C0.865234 2.45963 0.973927 2.1973 1.19131 1.9798C1.40881 1.76242 1.67114 1.65373 1.97829 1.65373H3.23777V1.10525C3.23777 0.798091 3.34647 0.535765 3.56385 0.318265C3.78123 0.10088 4.04356 -0.0078125 4.35083 -0.0078125H8.3181C8.62537 -0.0078125 8.8877 0.10088 9.10508 0.318265C9.32247 0.535765 9.43116 0.798091 9.43116 1.10525V1.65373H10.6906C10.9978 1.65373 11.2601 1.76242 11.4776 1.9798C11.695 2.1973 11.8037 2.45963 11.8037 2.76678V2.96911C11.8037 3.73515 11.5406 4.39659 11.0143 4.95344C10.4881 5.51017 9.84285 5.83394 9.07843 5.92475C8.89196 6.41201 8.59306 6.80963 8.18172 7.11759C7.77037 7.42555 7.30462 7.60573 6.78447 7.65811V10.0307H8.72829C8.85602 10.0307 8.96293 10.0733 9.049 10.1587C9.1352 10.2442 9.17829 10.3503 9.17829 10.477C9.17829 10.6037 9.1352 10.711 9.049 10.7988C8.96293 10.8867 8.85602 10.9306 8.72829 10.9306H3.94064C3.81291 10.9306 3.706 10.8879 3.61993 10.8024C3.53373 10.717 3.49064 10.611 3.49064 10.4843C3.49064 10.3576 3.53373 10.2503 3.61993 10.1625C3.706 10.0746 3.81291 10.0307 3.94064 10.0307H5.88447Z"
                  fill="url(#paint0_linear_5985_18867)" />
                <defs>
                  <linearGradient id="paint0_linear_5985_18867-2" x1="9.10397" y1="10.9999" x2="-0.126802" y2="1.30758"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="var(--primary-color)" />
                    <stop offset="1" stop-color="#00BFC7" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div id="st-common-score-cards-block-18" class="gap-1 d-flex align-items-center"
              *ngIf="shouldShowLiveScoreBlock(item)">
              <div id="st-common-score-cards-block-19" class="d-flex" style="gap: 2px"
                *ngIf="item.live_score_json.PlayerByellowCardCount > 0">
                <img class="card_img" src="../../../../assets/icons_svg/yellow_card.svg" alt="" />
                <!-- <p class="cards_text">
                  x {{ item.live_score_json.PlayerByellowCardCount }}
                </p> -->
              </div>
              <div id="st-common-score-cards-block-20" class="d-flex" style="gap: 2px" *ngIf="false">
                <img class="card_img" src="../../../../assets/icons_svg/red_card.svg" alt="" />
                <!-- <p class="cards_text">
                  x {{ item.live_score_json.PlayerBredCardCount }}
                </p> -->
              </div>
              <div id="st-common-score-cards-block-21" class="d-flex" style="gap: 2px"
                *ngIf="item.live_score_json.PlayerBredCardCount == 1">
                <img class="card_img" src="../../../../assets/SvgIcons/1_half.svg" alt="" />
              </div>
              <div id="st-common-score-cards-block-22" class="d-flex" style="gap: 2px"
                *ngIf="item.live_score_json.PlayerBredCardCount == 2">
                <img class="card_img" src="../../../../assets/SvgIcons/2_half.svg" alt="" />
              </div>
              <div id="st-common-score-cards-text-center-23" class="text-center game_score"
                *ngIf="shouldShowLiveScoreBlock(item)">
                <!-- {{item.participants[1].score[0]}} -->
                {{ item?.live_score_json?.sets?.[0]?.score_B }}
              </div>
              <!-- {{item?.live_score_json.sets[0]?.score_B}}</div> -->
            </div>
          </div>
          <div id="st-common-score-cards-points-container-24" class="d-flex points-container">
            <div id="st-common-score-cards-all-set-points-25" class="d-flex all-set-points">
              @for(point of item?.participants[1]?.score; track point){
              <div [id]="'st-common-score-cards-points-26' + (item.point)" class="points">{{ point }}</div>
              }
            </div>
            <div class="set_score lower_data" *ngIf="item.category.participant_type_id == 2">
              {{
              item.live_score_json != "winner announced" &&
              item.live_score_json != null &&
              item.winner == null
              ? get_set_won(item, item.sub_matches, 2)
              : get_set_won(item, item.sub_matches, 2)
              }}
            </div>
            <div id="st-common-score-cards-setscore-27" class="set_score lower_data"
              *ngIf="item.category.participant_type_id != 2">
              {{
              item.live_score_json != "winner announced" &&
              item.live_score_json != null &&
              item.winner == null
              ? item.participants?.[1]?.sets_won
              : item.participants?.[1]?.sets_won
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- style="display: none;" -->
  <div id="st-common-score-cards-arrowsection" class="arrow_section hover-content" #hoverContent style="display: none"
    *ngIf="show_arrow && screenWidth > 1024">
    <div id="st-common-score-cards-inner" class="inner">
      <p class="f_700 f_12">{{'view_more' | translate}}</p>
      <div id="st-common-score-cards-arrow" class="arrow">
        <img src="../../../../assets/icons_svg/view_arrow.svg" alt="" />
      </div>
    </div>
  </div>
</div>

<!-- ===== Default template-0 score card (premium layout). Legacy chrome is opt-in via [variant]="'classic'". ===== -->
 <div class="score_card_wrapper premium-score-card" [class.static-score-card]="!gradientalBackground" *ngIf="sport_id==1 && variant !== 'classic'"
[class.is-completed]="isMatchCompleted(item)"
[class.psc-is-singles]="item.category.participant_type_id === 1"
[class.psc-is-multi]="item.category.participant_type_id > 1"
(click)="navigate_to_scores()" (mouseenter)="onHover()"
  (mouseleave)="onLeave()">
  <!-- <span class="psc-accent" aria-hidden="true"></span> -->
  <div class="premium-default" #defaultContent>
    <header id="st-psc-head" class="psc-head">
      <div class="psc-meta">
        <p class="psc-tournament" title="{{ (item.category | categoryDisplayLabel) }} · {{ item.round.name }}">
          {{ (item.category | categoryDisplayLabel) }} · {{ item.round.name }}
        </p>
        <p class="psc-sub" *ngIf="gettables(item)">
          <span class="psc-table fw-semibold">{{ 'table' | translate | titlecase }} {{ gettables(item) }}</span>
          <span class="psc-sep" aria-hidden="true"></span>
          <span class="psc-time fw-semibold">{{ item.start_time | date:'HH:mm' }}</span>
        </p>
      </div>
      <div class="psc-head-actions">
        @if (item.category.participant_type_id == 2) {
        <div class="psc-team-scores" aria-hidden="true">
          <span class="psc-team-score first">
            {{ item.point_system === 'set_point_system' ? item.participants[0]?.match_points :
            item.participants[0]?.sets_won }}
          </span>
          <span class="psc-team-score second">
            {{ item.point_system === 'set_point_system' ? item.participants[1]?.match_points :
            item.participants[1]?.sets_won }}
          </span>
        </div>
        }
        <div class="psc-status" [class.completed]="isMatchCompleted(item)" [class.live]="!isMatchCompleted(item)">
          <span class="psc-live-pulse" *ngIf="!isMatchCompleted(item)" aria-hidden="true"></span>
          {{ isMatchCompleted(item) ? ('completed' | translate) : ('live' | translate) }}
        </div>
      </div>
    </header>

    <div class="psc-players">
      <!-- Participant 1 -->
      <div class="psc-player"
        [class.is-winner]="item.winner != null && item.winner === item.participants[0]?.participant_id"
        [class.is-loser]="item.winner != null && item.winner !== item.participants[0]?.participant_id">
        <div class="psc-identity">
          <i class="bi bi-trophy-fill psc-trophy" *ngIf="item.winner == item.participants[0]?.participant_id"></i>
          <div class="psc-names">
            <ng-container
              *ngTemplateOutlet="nameCard; context: {
              player: item?.participants[0]?.participant_details[0], type: 1, mini: true, item: item, index: 0,
              img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
            <ng-container *ngIf="item.category.participant_type_id > 1">
              <ng-container
                *ngTemplateOutlet="nameCard; context: {
                player: item?.participants[0]?.participant_details[1], type: 1, mini: true, item: item, index: 1,
                img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
            </ng-container>
          </div>
          <div class="psc-inline-icons">
            <svg class="service_icon psc-service" *ngIf="
                item.live_score_json?.ServiceBy === item.live_score_json?.participant_id_A && item.winner == null"
              width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M2.0625 0.25C1.34281 0.25 0.75 0.842812 0.75 1.5625C0.75 2.28219 1.34281 2.875 2.0625 2.875C2.78219 2.875 3.375 2.28219 3.375 1.5625C3.375 0.842812 2.78219 0.25 2.0625 0.25ZM7.28537 0.646375C7.1482 0.648832 7.01124 0.658177 6.875 0.674375C5.79481 0.800812 4.78681 1.35425 4.01769 2.12337C3.47737 2.6615 3.02981 3.43587 2.88281 4.87131C2.87752 4.88476 2.873 4.89849 2.86925 4.91244V4.926C2.85827 4.94813 2.84905 4.9711 2.84169 4.99469C2.83994 5.00475 2.84344 5.01 2.84169 5.02181V5.0765C2.84576 5.13316 2.85967 5.18868 2.88281 5.24056C2.90469 5.63387 2.95981 6.0355 3.10156 6.41656H3.088C3.09456 6.45419 3.13919 6.64187 3.14269 6.8265C3.14444 6.96519 3.09456 7.09162 3.088 7.1275C2.82112 7.39219 2.50175 7.66912 2.19944 7.90669C1.89669 8.14425 1.63506 8.34944 1.44694 8.53581H1.43381C1.32136 8.65426 1.23902 8.798 1.19372 8.95492C1.14841 9.11184 1.14148 9.27734 1.1735 9.4375C1.24 9.74375 1.41587 10.0084 1.65169 10.2442C1.88619 10.4783 2.15262 10.6524 2.45844 10.7224C2.76469 10.7924 3.13525 10.7023 3.37456 10.463C3.56619 10.2714 3.75081 10.0014 3.98969 9.69737C4.229 9.39287 4.50069 9.063 4.76887 8.79481C4.73825 8.82544 4.87169 8.75412 5.04275 8.75412C5.181 8.75412 5.29562 8.76725 5.384 8.78125C5.40675 8.78475 5.45269 8.79306 5.46625 8.79481C5.84731 8.93656 6.24937 8.98994 6.64225 9.01356C6.64706 9.01356 6.651 9.02756 6.65581 9.02756C6.68644 9.03587 6.71925 9.03937 6.75163 9.04069C6.76492 9.04611 6.7785 9.05078 6.79231 9.05469H6.875C6.90256 9.05294 6.92969 9.04769 6.95725 9.04112C6.97431 9.03937 6.98088 9.02887 6.99794 9.02712H7.01194C8.32925 8.91775 9.21256 8.44087 9.77344 7.87869C10.5426 7.11 11.096 6.10156 11.2229 5.02181C11.3493 3.94119 11.0124 2.78794 10.0604 1.83594C9.22831 1.00381 8.24219 0.639813 7.28537 0.646375ZM2.0625 1.125C2.30881 1.125 2.5 1.31662 2.5 1.5625C2.5 1.80881 2.30837 2 2.0625 2C1.81619 2 1.625 1.80837 1.625 1.5625C1.625 1.31619 1.81662 1.125 2.0625 1.125ZM7.28537 1.52137C8.02344 1.50781 8.76325 1.76944 9.44531 2.45106C10.2262 3.23025 10.4472 4.08294 10.3479 4.92556C10.2486 5.76819 9.80581 6.61606 9.15788 7.26356C8.72256 7.69931 8.09037 8.03969 6.98437 8.13856L3.75781 4.912C3.886 3.67825 4.19006 3.20837 4.64637 2.75206C5.29387 2.10456 6.12644 1.64781 6.97081 1.54894C7.07669 1.53669 7.1795 1.52312 7.28537 1.52137ZM3.96256 6.375L5.52094 7.91981C5.36289 7.89232 5.20273 7.8787 5.04231 7.87912C4.77587 7.88044 4.43769 7.89619 4.15419 8.17969C3.85276 8.48637 3.56964 8.81054 3.30631 9.1505C3.06175 9.46112 2.84475 9.74856 2.74588 9.84744C2.69425 9.89906 2.71962 9.89031 2.64962 9.875C2.57962 9.85969 2.43787 9.77262 2.28081 9.61512C2.12681 9.46156 2.05025 9.31937 2.0345 9.24631C2.01919 9.17281 2.00387 9.19294 2.0485 9.15006C2.14037 9.05819 2.41906 8.83594 2.73187 8.59006C3.04469 8.34375 3.40169 8.05631 3.71625 7.74219C4.019 7.43987 4.0225 7.08944 4.01725 6.8125C4.01375 6.6025 3.98137 6.47912 3.96256 6.375Z"
                fill="var(--primary-color)" />
            </svg>
            <img src="../../../../assets/SvgIcons/timeout.svg" alt="" *ngIf="item.PlayerATimeout" class="psc-timeout" />
          </div>
        </div>
        <div class="psc-scoreline">
          @if (shouldShowLiveScoreBlock(item)) {
          <div class="psc-live-meta">
            @if (item.live_score_json?.PlayerAyellowCardCount > 0) {
            <img class="psc-card" src="../../../../assets/icons_svg/yellow_card.svg" alt="" />
            }
            @if (item.live_score_json?.PlayerAredCardCount == 1) {
            <img class="psc-card" src="../../../../assets/SvgIcons/1_half.svg" alt="" />
            }
            @if (item.live_score_json?.PlayerAredCardCount == 2) {
            <img class="psc-card" src="../../../../assets/SvgIcons/2_half.svg" alt="" />
            }
            <span class="psc-live-score">{{ item?.live_score_json?.sets?.[0]?.score_A }}</span>
          </div>
          }
          <div class="psc-points">
            @for(point of item.participants[0]?.score; track point){
            <span class="psc-point">{{ point }}</span>
            }
          </div>
          <span class="psc-sets">{{ item.category.participant_type_id == 2 ? get_set_won(item, item.sub_matches, 1) :
            item.participants[0]?.sets_won }}</span>
        </div>
      </div>

      <span class="psc-vs" aria-hidden="true"></span>

      <!-- Participant 2 -->
      <div class="psc-player"
        [class.is-winner]="item.winner != null && item.winner === item.participants[1]?.participant_id"
        [class.is-loser]="item.winner != null && item.winner !== item.participants[1]?.participant_id">
        <div class="psc-identity">
          <i class="bi bi-trophy-fill psc-trophy" *ngIf="item.winner == item.participants[1]?.participant_id"></i>
          <div class="psc-names">
            <ng-container
              *ngTemplateOutlet="nameCard; context: {
              player: item?.participants[1]?.participant_details[0], type: 2, mini: true, item: item, index: 0,
              img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
            <ng-container *ngIf="item.category.participant_type_id > 1">
              <ng-container
                *ngTemplateOutlet="nameCard; context: {
                player: item?.participants[1]?.participant_details[1], type: 2, mini: true, item: item, index: 1,
                img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
            </ng-container>
          </div>
          <div class="psc-inline-icons">
            <svg class="service_icon psc-service" *ngIf="
                item.live_score_json?.ServiceBy === item.live_score_json?.participant_id_B && item.winner == null"
              width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M2.0625 0.25C1.34281 0.25 0.75 0.842812 0.75 1.5625C0.75 2.28219 1.34281 2.875 2.0625 2.875C2.78219 2.875 3.375 2.28219 3.375 1.5625C3.375 0.842812 2.78219 0.25 2.0625 0.25ZM7.28537 0.646375C7.1482 0.648832 7.01124 0.658177 6.875 0.674375C5.79481 0.800812 4.78681 1.35425 4.01769 2.12337C3.47737 2.6615 3.02981 3.43587 2.88281 4.87131C2.87752 4.88476 2.873 4.89849 2.86925 4.91244V4.926C2.85827 4.94813 2.84905 4.9711 2.84169 4.99469C2.83994 5.00475 2.84344 5.01 2.84169 5.02181V5.0765C2.84576 5.13316 2.85967 5.18868 2.88281 5.24056C2.90469 5.63387 2.95981 6.0355 3.10156 6.41656H3.088C3.09456 6.45419 3.13919 6.64187 3.14269 6.8265C3.14444 6.96519 3.09456 7.09162 3.088 7.1275C2.82112 7.39219 2.50175 7.66912 2.19944 7.90669C1.89669 8.14425 1.63506 8.34944 1.44694 8.53581H1.43381C1.32136 8.65426 1.23902 8.798 1.19372 8.95492C1.14841 9.11184 1.14148 9.27734 1.1735 9.4375C1.24 9.74375 1.41587 10.0084 1.65169 10.2442C1.88619 10.4783 2.15262 10.6524 2.45844 10.7224C2.76469 10.7924 3.13525 10.7023 3.37456 10.463C3.56619 10.2714 3.75081 10.0014 3.98969 9.69737C4.229 9.39287 4.50069 9.063 4.76887 8.79481C4.73825 8.82544 4.87169 8.75412 5.04275 8.75412C5.181 8.75412 5.29562 8.76725 5.384 8.78125C5.40675 8.78475 5.45269 8.79306 5.46625 8.79481C5.84731 8.93656 6.24937 8.98994 6.64225 9.01356C6.64706 9.01356 6.651 9.02756 6.65581 9.02756C6.68644 9.03587 6.71925 9.03937 6.75163 9.04069C6.76492 9.04611 6.7785 9.05078 6.79231 9.05469H6.875C6.90256 9.05294 6.92969 9.04769 6.95725 9.04112C6.97431 9.03937 6.98088 9.02887 6.99794 9.02712H7.01194C8.32925 8.91775 9.21256 8.44087 9.77344 7.87869C10.5426 7.11 11.096 6.10156 11.2229 5.02181C11.3493 3.94119 11.0124 2.78794 10.0604 1.83594C9.22831 1.00381 8.24219 0.639813 7.28537 0.646375ZM2.0625 1.125C2.30881 1.125 2.5 1.31662 2.5 1.5625C2.5 1.80881 2.30837 2 2.0625 2C1.81619 2 1.625 1.80837 1.625 1.5625C1.625 1.31619 1.81662 1.125 2.0625 1.125ZM7.28537 1.52137C8.02344 1.50781 8.76325 1.76944 9.44531 2.45106C10.2262 3.23025 10.4472 4.08294 10.3479 4.92556C10.2486 5.76819 9.80581 6.61606 9.15788 7.26356C8.72256 7.69931 8.09037 8.03969 6.98437 8.13856L3.75781 4.912C3.886 3.67825 4.19006 3.20837 4.64637 2.75206C5.29387 2.10456 6.12644 1.64781 6.97081 1.54894C7.07669 1.53669 7.1795 1.52312 7.28537 1.52137ZM3.96256 6.375L5.52094 7.91981C5.36289 7.89232 5.20273 7.8787 5.04231 7.87912C4.77587 7.88044 4.43769 7.89619 4.15419 8.17969C3.85276 8.48637 3.56964 8.81054 3.30631 9.1505C3.06175 9.46112 2.84475 9.74856 2.74588 9.84744C2.69425 9.89906 2.71962 9.89031 2.64962 9.875C2.57962 9.85969 2.43787 9.77262 2.28081 9.61512C2.12681 9.46156 2.05025 9.31937 2.0345 9.24631C2.01919 9.17281 2.00387 9.19294 2.0485 9.15006C2.14037 9.05819 2.41906 8.83594 2.73187 8.59006C3.04469 8.34375 3.40169 8.05631 3.71625 7.74219C4.019 7.43987 4.0225 7.08944 4.01725 6.8125C4.01375 6.6025 3.98137 6.47912 3.96256 6.375Z"
                fill="var(--primary-color)" />
            </svg>
            <img src="../../../../assets/SvgIcons/timeout.svg" alt="" *ngIf="item.PlayerATimeout" class="psc-timeout" />
          </div>
        </div>
        <div class="psc-scoreline">
          @if (shouldShowLiveScoreBlock(item)) {
          <div class="psc-live-meta">
            @if (item.live_score_json?.PlayerByellowCardCount > 0) {
            <img class="psc-card" src="../../../../assets/icons_svg/yellow_card.svg" alt="" />
            }
            @if (item.live_score_json?.PlayerBredCardCount == 1) {
            <img class="psc-card" src="../../../../assets/SvgIcons/1_half.svg" alt="" />
            }
            @if (item.live_score_json?.PlayerBredCardCount == 2) {
            <img class="psc-card" src="../../../../assets/SvgIcons/2_half.svg" alt="" />
            }
            <span class="psc-live-score">{{ item?.live_score_json?.sets?.[0]?.score_B }}</span>
          </div>
          }
          <div class="psc-points">
            @for(point of item?.participants[1]?.score; track point){
            <span class="psc-point">{{ point }}</span>
            }
          </div>
          <span class="psc-sets">{{ item.category.participant_type_id == 2 ? get_set_won(item, item.sub_matches, 2) :
            item.participants?.[1]?.sets_won }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Previous "view more" reveal: full-card glassmorphism overlay, gsap-driven (onHover/onLeave) -->
  <div class="arrow_section hover-content premium-view-more" #hoverContent style="display: none"
    *ngIf="show_arrow && screenWidth > 1024">
    <div class="inner">
      <p class="f_700 f_12">{{'view_more' | translate}}</p>
      <div class="arrow">
        <img src="../../../../assets/icons_svg/view_arrow.svg" alt="" />
      </div>
    </div>
  </div>
</div>

<!-- Court-surface sports — premium layout (tennis/padel etc.) -->
<div class="score_card_wrapper premium-score-card mt-2" *ngIf="isCourtSurfaceSport"
  [class.is-completed]="isMatchCompleted(item)" [class.psc-is-singles]="item.category.participant_type_id === 1"
  [class.psc-is-multi]="item.category.participant_type_id > 1" (click)="navigate_to_scores()" (mouseenter)="onHover()"
  (mouseleave)="onLeave()">
  <div class="premium-default" #defaultContent>
    <header class="psc-head">
      <div class="psc-meta">
        <p class="psc-tournament" title="{{ (item.category | categoryDisplayLabel) }} · {{ item.round.name }}">
          {{ (item.category | categoryDisplayLabel) }} · {{ item.round.name }}
        </p>
        <p class="psc-sub" *ngIf="gettables(item)">
          <span class="psc-table">{{ 'table' | translate | titlecase }} {{ gettables(item) }}</span>
        </p>
      </div>
      <div class="psc-head-actions">
        @if (item.category.participant_type_id == 2) {
        <div class="psc-team-scores" aria-hidden="true">
          <span class="psc-team-score first">
            {{ item.point_system === 'set_point_system' ? item.participants[0]?.match_points :
            item.participants[0]?.sets_won }}
          </span>
          <span class="psc-team-score second">
            {{ item.point_system === 'set_point_system' ? item.participants[1]?.match_points :
            item.participants[1]?.sets_won }}
          </span>
        </div>
        }
        <div class="psc-status" [class.completed]="isMatchCompleted(item)" [class.live]="!isMatchCompleted(item)">
          <span class="psc-live-pulse" *ngIf="!isMatchCompleted(item)" aria-hidden="true"></span>
          {{ isMatchCompleted(item) ? ('completed' | translate) : ('live' | translate) }}
        </div>
      </div>
    </header>

    <div class="psc-players">
      <div class="psc-player"
        [class.is-winner]="item.winner != null && item.winner === item.participants[0]?.participant_id"
        [class.is-loser]="item.winner != null && item.winner !== item.participants[0]?.participant_id">
        <div class="psc-identity">
          <i class="bi bi-trophy-fill psc-trophy" *ngIf="item.winner == item.participants[0]?.participant_id"></i>
          <div class="psc-names">
            <ng-container
              *ngTemplateOutlet="nameCard; context: {
              player: item?.participants[0]?.participant_details[0], type: 1, mini: true, item: item, index: 0,
              img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
            <ng-container *ngIf="item.category.participant_type_id > 1">
              <ng-container
                *ngTemplateOutlet="nameCard; context: {
                player: item?.participants[0]?.participant_details[1], type: 1, mini: true, item: item, index: 1,
                img_details: item?.participants[0], selected_parents: item?.participants[0]?.selected_parents }"></ng-container>
            </ng-container>
          </div>
          <div class="psc-inline-icons">
            <img class="psc-service-img" *ngIf="
                item.live_score_json?.ServiceBy === item.live_score_json?.participant_id_A && item.winner == null"
              [src]="serviceIcon" alt="" width="14" height="14" />
          </div>
        </div>
        <div class="psc-scoreline">
          <div class="psc-points">
            @for (point of item?.participants[0]?.points; track $index) {
            <span class="psc-point">{{ point }}<sup *ngIf="item?.participants[0]?.tie_sets?.[$index]">{{
                item?.participants[0]?.tie_sets[$index] }}</sup></span>
            }
          </div>
          <span class="psc-sets">{{ item.category.participant_type_id == 2 ? get_set_won(item, item.sub_matches, 1) :
            item.participants[0]?.sets_won }}</span>
        </div>
      </div>

      <span class="psc-vs" aria-hidden="true"></span>

      <div class="psc-player"
        [class.is-winner]="item.winner != null && item.winner === item.participants[1]?.participant_id"
        [class.is-loser]="item.winner != null && item.winner !== item.participants[1]?.participant_id">
        <div class="psc-identity">
          <i class="bi bi-trophy-fill psc-trophy" *ngIf="item.winner == item.participants[1]?.participant_id"></i>
          <div class="psc-names">
            <ng-container
              *ngTemplateOutlet="nameCard; context: {
              player: item?.participants[1]?.participant_details[0], type: 2, mini: true, item: item, index: 0,
              img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
            <ng-container *ngIf="item.category.participant_type_id > 1">
              <ng-container
                *ngTemplateOutlet="nameCard; context: {
                player: item?.participants[1]?.participant_details[1], type: 2, mini: true, item: item, index: 1,
                img_details: item?.participants[1], selected_parents: item?.participants[1]?.selected_parents }"></ng-container>
            </ng-container>
          </div>
          <div class="psc-inline-icons">
            <img class="psc-service-img" *ngIf="
                item.live_score_json?.ServiceBy === item.live_score_json?.participant_id_B && item.winner == null"
              [src]="serviceIcon" alt="" width="14" height="14" />
          </div>
        </div>
        <div class="psc-scoreline">
          <div class="psc-points">
            @for (point of item?.participants[1]?.points; track $index) {
            <span class="psc-point">{{ point }}<sup *ngIf="item?.participants[1]?.tie_sets?.[$index]">{{
                item?.participants[1]?.tie_sets[$index] }}</sup></span>
            }
          </div>
          <span class="psc-sets">{{ item.category.participant_type_id == 2 ? get_set_won(item, item.sub_matches, 2) :
            item.participants?.[1]?.sets_won }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="arrow_section hover-content premium-view-more" #hoverContent style="display: none"
    *ngIf="show_arrow && screenWidth > 1024">
    <div class="inner">
      <p class="f_700 f_12">{{ 'view_more' | translate }}</p>
      <div class="arrow">
        <img src="../../../../assets/icons_svg/view_arrow.svg" alt="" />
      </div>
    </div>
  </div>
</div>

}